import { Button, Card, Form, Input } from 'antd';
import { useUnit } from 'effector-react';
import { useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import {
    $authStatus,
    loginEv,
    loginFx,
// } from '../../models/authModel/index.js';
} from '../../models/authModel/index.js';
import { cookies } from '../../api/axiosinstance.js';
import style from './Login.module.css';

export default function Login() {
    const authStatus = useUnit($authStatus);
    const onLogin = useUnit(loginEv);
    const navigate = useNavigate();
    const isLoading = useUnit(loginFx.pending);

    useEffect(() => {
        if (authStatus) {
            const token = cookies.get('access_token');
            if (token) {
                navigate('/');
            }
        }
    }, [authStatus]);

    return (
        <div className={style.login_wrapper}>
            <div className={style.login_form_wrapper}>
                <div className={style.login_form} id="login-form">
                    <Form
                        name="loginForm"
                        id="loginForm"
                        onFinish={onLogin}
                        layout="vertical"
                        style={{ marginTop: 30 }}
                    >
                        <Form.Item name="username" label="Логин">
                            <Input
                                placeholder="email@email.com"
                                className={style.login_input}
                            />
                        </Form.Item>
                        <Form.Item name="password" label="Пароль">
                            <Input.Password
                                allowClear
                                placeholder="********"
                                className={style.login_input}
                            />
                        </Form.Item>
                        <Button
                            loading={isLoading}
                            htmlType="submit"
                            form="loginForm"
                            type="primary"
                            className={style.login_button}
                        >
                            Войти
                        </Button>

                    </Form>
                </div>
            </div>

        </div>
    );
}
